import {useState} from 'react';
import {creditFactory} from '../store/creditFactory';
import {Store} from '../../stores/models/store.model';
import StandardizedErrorHandler from '../../../Services/common/StandardizedErrorHandler';

export const useUpdateCreditLimit = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const errorHandlingService = StandardizedErrorHandler.getInstance();

  const updateCreditLimit = async (
    storeId: number,
    payload: { credit_limit: number; reason?: string }
  ): Promise<Store> => {
    setLoading(true);
    setError(null);

    try {
      const useCases = creditFactory.getUseCases();
      const updatedStore = await useCases.updateCreditLimit.execute(storeId, payload);
      return updatedStore;
    } catch (err) {
      const appError = errorHandlingService.toAppError(err);
      setError(appError.message);
      errorHandlingService.handleError(err); // For notifications/logging
      throw appError;
    } finally {
      setLoading(false);
    }
  };

  return {
    updateCreditLimit,
    loading,
    error
  };
};
